import { Link } from "react-router-dom";
import { 
  Facebook, 
  Instagram, 
  Linkedin, 
  MessageCircle, 
  Phone, 
  Mail,
  MapPin,
  Lock
} from "lucide-react";

// TikTok icon component (custom SVG to match Lucide style)
const TikTok = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ad8cae97-e844-4242-bf8a-3cc50b57fa19/artifacts/vj8eyvuz_logo%20%2B%20personaggio%20-%208energy%20srl%20%20%281%29.svg";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-border pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img src={LOGO_URL} alt="8energy" className="h-10" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6">
              Il tuo assistente energetico personale. Analizziamo le tue bollette con l'AI per farti risparmiare davvero.
            </p>
            
            {/* Social Icons - New Style */}
            <div className="flex gap-3">
              <a 
                href="https://www.facebook.com/profile.php?id=61584844715791&locale=it_IT" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-9 h-9 rounded-full bg-[#f5f5f7] flex items-center justify-center text-[#1d1d1f] hover:bg-[#ADFF2F] hover:text-[#006838] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_20px_rgba(173,255,47,0.3)]"
              >
                <Facebook className="w-4 h-4" />
              </a>
              
              <a 
                href="https://www.instagram.com/8energy_solutions/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-9 h-9 rounded-full bg-[#f5f5f7] flex items-center justify-center text-[#1d1d1f] hover:bg-[#ADFF2F] hover:text-[#006838] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_20px_rgba(173,255,47,0.3)]"
              >
                <Instagram className="w-4 h-4" />
              </a>
              
              <a 
                href="https://www.tiktok.com/@8energy_solutions" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-9 h-9 rounded-full bg-[#f5f5f7] flex items-center justify-center text-[#1d1d1f] hover:bg-[#ADFF2F] hover:text-[#006838] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_20px_rgba(173,255,47,0.3)]"
              >
                <TikTok className="w-4 h-4" />
              </a>
              
              <a 
                href="https://www.linkedin.com/company/8energy-srl" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-9 h-9 rounded-full bg-[#f5f5f7] flex items-center justify-center text-[#1d1d1f] hover:bg-[#ADFF2F] hover:text-[#006838] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_20px_rgba(173,255,47,0.3)]"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-foreground mb-6">Menu</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors text-sm">Home</Link>
              </li>
              <li>
                <Link to="/upload" className="text-muted-foreground hover:text-primary transition-colors text-sm">Analisi Bolletta</Link>
              </li>
              <li>
                <Link to="/switch-guide" className="text-muted-foreground hover:text-primary transition-colors text-sm">Come Funziona</Link>
              </li>
              <li>
                <Link to="/activation" className="text-muted-foreground hover:text-primary transition-colors text-sm">Richiedi Attivazione</Link>
              </li>
              <li>
                <Link to="/auth" className="text-muted-foreground hover:text-primary transition-colors text-sm">Accedi / Registrati</Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-bold text-foreground mb-6">Legale</h3>
            <ul className="space-y-4">
              <li>
                <a href="https://www.8energysolutions.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors text-sm">Privacy Policy</a>
              </li>
              <li>
                <a href="https://www.8energysolutions.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors text-sm">Termini e Condizioni</a>
              </li>
              <li>
                <a href="https://www.8energysolutions.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors text-sm">Cookie Policy</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-foreground mb-6">Contatti</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center shrink-0">
                  <MessageCircle className="w-4 h-4 text-green-600" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground font-medium mb-1">WhatsApp</p>
                  <a href="https://wa.me/393927451191" target="_blank" rel="noopener noreferrer" className="text-foreground hover:text-primary font-medium text-sm block">
                    +39 392 745 1191
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <Mail className="w-4 h-4 text-primary" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground font-medium mb-1">Email</p>
                  <a href="mailto:info@8energysolutions.com" className="text-foreground hover:text-primary font-medium text-sm block">
                    info@8energysolutions.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center shrink-0">
                  <MapPin className="w-4 h-4 text-gray-600" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground font-medium mb-1">Sede Legale</p>
                  <p className="text-sm text-foreground">
                    Via Enrico Fermi, 48<br />
                    Osmannoro, Sesto Fiorentino<br />
                    Metropolitan City of Florence, Italy
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3 pt-2">
                <a href="https://www.8energy.it" target="_blank" rel="noopener noreferrer" className="w-full">
                  <button className="w-full bg-primary text-white rounded-lg py-2 px-4 text-sm font-medium hover:bg-primary/90 transition-colors">
                    Vai al sito www.8energy.it
                  </button>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © 2026 8energy Srl. P.IVA 07504390480 | REA FI-708168 | PEC: 8energysrl@cndlpec.it — made by <a href="https://www.designermara.it" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors font-medium">MARA</a>
          </p>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Link to="/admin/login" className="hover:text-primary transition-colors flex items-center gap-1">
              <Lock className="w-3 h-3" />
              Area Riservata
            </Link>
            <span>•</span>
            <span className="bg-orange-100 text-orange-600 px-2 py-0.5 rounded font-medium">BETA</span>
            <span>•</span>
            <span>Powered by Google Gemini AI</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
